import React from "react";

/**
 * Compact scope picker shared by every broker module on a koncern workspace.
 * Renders a single <select> that mirrors the dataroom's existing pattern:
 *   ""     → parent only (default)
 *   "all"  → whole koncern combined
 *   orgnr  → a specific subsidiary
 *
 * Hidden when the workspace has no subsidiaries.
 *
 * Props:
 *   koncernInfo — from useKoncernMembers(): { parent: {orgnr, name}, members: [...] }
 *   scope, setScope — from useKoncernScope()
 *   style — optional inline style overrides
 */
export default function KoncernScopePicker({ koncernInfo, scope, setScope, style }) {
  if (!koncernInfo || !koncernInfo.members || koncernInfo.members.length === 0) {
    return null;
  }

  return (
    <select
      value={scope ?? ""}
      onChange={(e) => {
        const val = e.target.value;
        setScope(val === "" ? null : val);
      }}
      style={{
        fontSize: 13,
        padding: "6px 10px",
        border: "1px solid #d1d5db",
        borderRadius: 6,
        background: "#fff",
        color: "#374151",
        cursor: "pointer",
        minWidth: 180,
        ...style,
      }}
      title="Välj bolag eller hela koncernen"
    >
      <option value="">{koncernInfo.parent.name || "Moderbolag"}</option>
      <option value="all">Hela koncernen</option>
      {koncernInfo.members.map((m) => (
        <option key={m.orgnr} value={m.orgnr}>{m.name || m.orgnr}</option>
      ))}
    </select>
  );
}
